
import { Modal } from 'antd';
import styles from './index.module.scss';

type Props = {
  title?: string
  content?: string
  okText?: string
  cancelText?: string
  onOk?: () => void
}

const ConfirmModal = (props: Props) => {
  const { title, content, okText = '确定', cancelText = '取消', onOk } = props;
  Modal.confirm({
    title,
    icon: '',
    content,
    okText,
    cancelText,
    onOk,
    centered: true,
    className: styles.modal,
    autoFocusButton: null
  });
};

export default ConfirmModal;
